/*
 * @Description:
 * @Author: xiaoHai
 * @Date: 2021-10-19 09:27:24
 * @LastEditTime: 2021-10-19 09:30:38
 */
import Vue from 'vue';
import Router from 'vue-router';

import Home from '../pages/Home.vue';
import Product from '../pages/Product.vue';
import About from '../pages/About.vue';
import Join from '../pages/Join.vue';
import Business from '../pages/Business.vue';
import Privacy from '../pages/Privacy.vue';
import productLis from '../pages/paoductList.vue';
import rotation from '../pages/components/rotation.vue';
import PrivacyLjyd from '../pages/PrivacyLjyd.vue';
import PrivacyFy from '../pages/PrivacyFy.vue';
import PrivacyFl from '../pages/PrivacyFl.vue';
import PrivacyXiaoMi from '../pages/PrivacyXiaoMi.vue';
import PrivacyOppo from '../pages/PrivacyOppo.vue';
import LandingPage from '../pages/LandingPage.vue';
import PrivacyHuaWei from '../pages/PrivacyHuaWei1.vue';
Vue.use(Router);

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
    routes: [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/home',
            component: Home,
        },
        {
            path: '/product',
            component: Product,
        },
        {
            path: '/about',
            component: About,
        },
        {
            path: '/join',
            component: Join,
        },
        {
            path: '/business',
            component: Business,
        },
        {
            path: '/privacy',
            component: Privacy,
        },
        {
            path: '/productList',
            component: productLis,
        },
        {
            path: '/rotation',
            component: rotation,
        },
        {
            path: '/privacyLjyd',
            component: PrivacyLjyd,
            meta: {
                // 页面标题title
                title: '六角一袋',
            },
        },
        {
            path: '/privacyFy',
            component: PrivacyFy,
            meta: {
                // 页面标题title
                title: '风扬互动',
            },
        },
        {
            path: '/privacyFl',
            component: PrivacyFl,
            meta: {
                // 页面标题title
                title: '隐私政策',
            },
        },
        {
            path: '/privacyXiaoMi',
            component: PrivacyXiaoMi,
            meta: {
                // 页面标题title
                title: '小米隐私政策',
            },
        },
        {
            path: '/PrivacyOppo',
            component: PrivacyOppo,
            meta: {
                // 页面标题title
                title: '隐私政策',
            },
        },
        {
            path: '/LandingPage',
            component: LandingPage,
        },
        {
            path: '/PrivacyHuaWei',
            component: PrivacyHuaWei,
        },
    ],
});
